import { createFileRoute } from "@tanstack/react-router";
import SiteSearch from "@/pages/SiteSearch";

export const Route = createFileRoute("/search")({
  validateSearch: (s: Record<string, unknown>) => ({
    q: typeof s['q'] === "string" ? (s['q'] as string) : "",
    facet: typeof s['facet'] === "string" ? (s['facet'] as string) : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Search Results | Rex & Sons RVs" },
      { name: "description", content: "Search RV inventory, buying guides and pages across Rex & Sons RVs." },
      { property: "og:title", content: "Search Rex & Sons RVs" },
      { property: "og:description", content: "Find RVs, guides and information across our site." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: SiteSearch,
});
